import {
    useCallback,
} from 'react'

import useFilter from 'app/hooks/useFilter/useFilter'
import {
    useGetRequestSpreadSheetAdapter,
} from 'app/shared-components/SkyNetSpreadSheet'
import useSimpleApiRequest from 'app/hooks/useSimpleApiRequest'
import StatusHandler from 'app/shared-components/StatusHandler'
import {
    AsyncMutationOptions,
} from 'app/types/request.types'
import {
    useSkyNetPagination, SkyNetPaginationContext,
} from 'app/shared-components/SkyNetPagination'
import {
    RequestKeys,
} from 'app/hooks/useRequest'

import requests from 'app/requests/Prebooking.requests'
import {
    PreBooking,
} from '../PreBooking.types'
import PreBookingSpreadsheet from '../PreBookingSpreadsheet'
import {
    convertToPrebookingEntity,
    convertToPrebookingEntitySpreadsheetData,
} from '../PreBookingSpreadsheet/PrebookingSpreadsheet.utils'
import {
    PreBookingEntitySpreadsheetData,
} from '../PreBookingSpreadsheet/PreBookingSpreadsheet.config'

const PreBookingBulkEdit = ({
    onClose,
}: Readonly<{ onClose: () => {} }>) => {
    const filterOptions = useFilter()
    const paginationOptions = useSkyNetPagination(25)

    const {
        isError,
        loaded,
        error,
        refetch,
    } = useGetRequestSpreadSheetAdapter<PreBooking, PreBookingEntitySpreadsheetData>({
        filterOptions,
        paginationOptions,
        dataAdapter: convertToPrebookingEntitySpreadsheetData,
        config: requests.filterRequestForBulkEdit,
        requestKey: RequestKeys.getPreBookings,
        enabled: false,
    })

    const {
        mutateAsync: prebookingBulkEdit,
    } = useSimpleApiRequest({
        name: 'PreBookingsBulkEdit',
        requestParams: requests.bulkEdit(),
        title: 'Pre-bookings were updated',
        onSuccess: refetch,
    })

    const onSave = useCallback(async (
        prebookings: PreBookingEntitySpreadsheetData[],
        options?: AsyncMutationOptions,
    ) => {
        await prebookingBulkEdit(convertToPrebookingEntity(prebookings), {
            ...options,
            onSuccess: options?.onSuccess || onClose,
        })
    }, [
        onClose,
        prebookingBulkEdit,
    ])

    return (
        <StatusHandler
            isError={isError}
            isFetching={!loaded}
            error={error}
            isSuccess={loaded}
        >
            <SkyNetPaginationContext.Provider value={paginationOptions}>
                <PreBookingSpreadsheet
                    onSave={onSave}
                    onCancel={onClose}
                    filterOptions={filterOptions}
                />
            </SkyNetPaginationContext.Provider>
        </StatusHandler>
    )
}

export default PreBookingBulkEdit
